import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { InfoGrid, QuoteSection } from "../components/site/Sections";
import { Steps } from "../components/site/Steps";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { scrollToId } from "../lib/site";

const ITEMS = [
  { title: "Edifícios comerciais e industriais", text: "Lojas, escritórios, armazéns, oficinas e unidades industriais podem aproveitar coberturas ou áreas livres para produzir energia para a própria atividade." },
  { title: "Consumo durante o dia", text: "Atividades com consumo diurno relevante tendem a aproveitar melhor a energia produzida. Por isso, o perfil horário de consumo é o ponto de partida da análise." },
  { title: "Área disponível", text: "Avaliamos a área útil da cobertura ou do terreno, a orientação, os sombreamentos e o tipo de estrutura para definir a potência possível." },
  { title: "Armazenamento, quando aplicável", text: "Em alguns perfis de consumo pode fazer sentido analisar um sistema com baterias. Esta opção é estudada caso a caso, sob consulta." },
  { title: "Proposta comercial", text: "A proposta descreve a solução, os equipamentos previstos e os pressupostos utilizados. As estimativas de produção são indicativas e não constituem valores garantidos." },
  { title: "Como pedir uma proposta", text: "Indique a atividade, a localização e as necessidades da instalação no formulário. Um registo de consumos ou faturas recentes ajuda a acelerar a análise." },
];

export default function EmpresarialPage() {
  return (
    <>
      <Seo title="Energia Solar para Empresas | Mega Solar" path="/solucoes-empresariais"
        description="Energia solar para empresas em Portugal: instalação fotovoltaica em edifícios comerciais e industriais, com análise do consumo diurno e da área disponível. Solicite uma proposta." />
      <PageHero testId="business-hero" eyebrow="Soluções empresariais" lines={["Soluções solares", "para empresas."]}
        text="Para empresas que pretendem avaliar o potencial de produção solar, melhorar a eficiência energética e gerir melhor os seus custos operacionais."
        image="/images/industrial.jpg" alt="Cobertura industrial com painéis solares fotovoltaicos vista de cima">
        <button type="button" onClick={() => scrollToId("formulario")} className="btn-gold mt-10" data-testid="business-hero-quote-button">Solicitar Proposta Empresarial</button>
      </PageHero>
      <InfoGrid testId="business-info" eyebrow="Como avaliamos" title="Uma análise orientada para a sua atividade." items={ITEMS} />
      <section className="bg-forest-deep py-24 text-white sm:py-32">
        <div className="container-x">
          <Eyebrow light>Processo</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold tracking-tight sm:text-5xl">Processo de pedido de proposta.</h2></Reveal>
          <div className="mt-16"><Steps light /></div>
        </div>
      </section>
      <QuoteSection tipo="empresarial" origem="empresarial" lockTipo title="Solicite uma proposta empresarial."
        text="Indique a atividade, a localização e as necessidades da instalação. Analisamos o pedido e entramos em contacto." />
    </>
  );
}
